export default "__VITE_ASSET__C5YelyvG__"